var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFiverr = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 41.861 41.861"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "fiverr_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h41.861v41.861H0z",
  "data-name": "Rectangle 7492"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 18858"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 18694"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#fiverr_svg__a)",
  "data-name": "Group 18693"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M24.687 16.729h-4.706c-.005 0 0-.04 0-.047v-.54a2.3 2.3 0 0 1 .176-.975 1.4 1.4 0 0 1 .23-.353 1.66 1.66 0 0 1 1.192-.531c.323-.007.651 0 .976-.005h2.133v-4.094h-3.659c-4.411.116-5.59 2.751-5.884 4.522a8 8 0 0 0-.074 1.031c0 .09 0 .988.006.988H12.27v4.093h2.807v10.859h4.9V20.822h4.706v10.855h4.9V16.729Z",
  "data-name": "Path 27242"
}))))));
export { SvgFiverr as ReactComponent };
export default __webpack_public_path__ + "static/media/fiverr.a46aeccbbecb4e7ebf12c7d6d995e54a.svg";